import { EditItem, IEditItem } from "./../common/editItem";
import { IModifyUser, ModifyUser } from "./../user/modifyUser";

export interface IWhistleBlowCategoryEditItem extends IEditItem {
    code: string;
    comment: string;
    activeState: number;
    modifyUser: IModifyUser;
}

export class WhistleBlowCategoryEditItem extends EditItem implements IWhistleBlowCategoryEditItem {
    code: string;
    comment: string;
    activeState: number;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IWhistleBlowCategoryEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.activeState = obj && obj.activeState || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}